export const VIEWPORT_SIZE = {
  DESKTOP: "desktop",
  MOBILE: "mobile"
};
